<template>
  <main class="content-page">
    <section class="submenu">
      <span class="highlight"></span>
      <h1 class="-h6">Tasks</h1>

      <section class="actions">
        <div class="btn-container">
          <Button
            :state="'primary'"
            :title="'Add Task'"
            @click="setModal('create')"
          />
        </div>
        <div class="search-container">
          <SearchBar />
        </div>
      </section>
    </section>

    <div class="listing"><TasksListing @setModal="setModal" /></div>
  </main>
</template>

<script>
import SearchBar from "../../../components/utils/BaseSearchBar.vue";
import Button from "../../../components/utils/BaseButton.vue";
import TasksListing from "../../../components/tables/mscope/TasksListing.vue";
export default {
  components: { SearchBar, Button, TasksListing },
  props: ["getRouteName"],
  methods: {
    setModal(cmd, item) {
      const route = this.getRouteName();
      const scopeModal = {
        cmd: cmd,
        scope: route,
        item: item,
      };
      this.$store.dispatch("scopeModal", scopeModal);
    },
  },
};
</script>

<style scoped>
@import url("../../../assets/scopeListings.css");
</style>